import { render, staticRenderFns } from "./porcentaje-mediano.vue?vue&type=template&id=967059ba&scoped=true&"
import script from "./porcentaje-mediano.vue?vue&type=script&lang=ts&"
export * from "./porcentaje-mediano.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967059ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
